import { FC } from 'react'

import { CircularProgress } from '@mui/material'
import cx from 'clsx'

import classes from './Loader.module.scss'

interface LoaderProps {
  className?: string
}

export const Loader: FC<LoaderProps> = ({ className }) => (
  <div className={cx(classes.wrap, className)}>
    <CircularProgress />
  </div>
)
